import { render, staticRenderFns } from "./AttachDiscussionDocument.vue?vue&type=template&id=7334c84d&scoped=true"
import script from "./AttachDiscussionDocument.vue?vue&type=script&lang=js"
export * from "./AttachDiscussionDocument.vue?vue&type=script&lang=js"
import style0 from "./AttachDiscussionDocument.vue?vue&type=style&index=0&id=7334c84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334c84d",
  null
  
)

export default component.exports